import { create } from "zustand";
import type { OAuthProvider } from "./oauth.types";

type OAuthState = {
	lastProvider: OAuthProvider | null;
	setLastProvider: (provider: OAuthProvider | null) => void;
	clear: () => void;
};

export const useOAuthStore = create<OAuthState>((set) => ({
	lastProvider: null,
	setLastProvider: (provider) => set({ lastProvider: provider }),
	clear: () => set({ lastProvider: null }),
}));
